import { useCallback, useMemo } from 'react'
import { FlaskConical } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchBacktest, FRAUD_STR as S, type BacktestRow } from './fraudApi'

/**
 * A25.04 — Бэктест правил. Replays a rule over historical events to measure how
 * many it would have matched/blocked. Dormant until `/admin/antifraud/backtest`
 * ships (fail-soft empty). Placeholder permission USERS_VIEW.
 */
export function BacktestScreen() {
  const columns = useMemo<AdminColumn<BacktestRow>[]>(
    () => [
      { key: 'rule', header: S.rule, type: 'text' },
      { key: 'sample', header: S.sample, type: 'number' },
      { key: 'matched', header: S.matched, type: 'number' },
      { key: 'would_block', header: S.wouldBlock, type: 'number' },
      { key: 'precision', header: S.precision, type: 'text' },
      { key: 'period', header: S.period, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchBacktest, [])
  return (
    <>
      <PageHeader title={S.backtest} screenId="A25.04" />
      <DataTable<BacktestRow>
        screenId="A25.04"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <FlaskConical size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
